module.exports = __webpack_public_path__ + "static/why-hexomatic-md-ba3b7666b734a128308f306aab172f68.png";